import { Divider } from 'antd';
import { InspectionPOItem } from 'app/modules/inspection/types';
import React from 'react';
import { POITEM_OVERALL_DESCRIPTION_DEFS } from './config';
import SubPOItemsDescriptionsTable from './sub-po';
import classes from './Description.module.scss';
import { Descriptions } from 'app/modules/ui';

type POItemDescriptionsProps = {
  item: InspectionPOItem;
};

export const POItemDescriptions = (props: POItemDescriptionsProps) => {
  const { item } = props;

  return (
    <div className={classes.description}>
      <Divider />
      <h5>Overall</h5>
      <Descriptions
        items={POITEM_OVERALL_DESCRIPTION_DEFS}
        value={item}
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 3, xxl: 3 }}
        className={classes['description__content']}
      ></Descriptions>
      {item?.isCustomSampling ? (
        <span className={classes.enableCustomize}>
          (Customize Sampling Plan)
        </span>
      ) : null}
      <h5>PO Detail:</h5>
      <SubPOItemsDescriptionsTable
        dataSource={item?.inspectionSubPOItems}
      ></SubPOItemsDescriptionsTable>
    </div>
  );
};
